import { DotText, PreText } from "component/basic";
import { comFormat, setDateTime, slideToggle, slideUp } from "js/function";
import { useEffect, useRef, useState } from "react";
import CountInput from "./count";

function FixedContents(data){

    return (
        <div className={`fixed_contents ${data.addClass||""}`}>
            {data.children}
        </div>
    );
};

function CarDetailSectionTitle(data){
    return (
        <h1 className={`carDetailSection_title ${data.addClass||""}`} dangerouslySetInnerHTML={{__html:data.title}}/>
    );
}

function CarDetailSectionSubTitle(data){
    return (
        <h1 className={`carDetailSection_subTitle ${data.addClass||""}`} dangerouslySetInnerHTML={{__html:data.title}}/>
    );
}

function CarDetailSectionCaptionBox(data){
    return (
        <div className="carDetailSection_captionBox">
            {data.children}
        </div>
    );
}

function CarDetailSectionTitleArea(data){
    return (
        <div className="carDetailSection_titleArea">
            {data.children}
        </div>
    );
}

function CarDetailSection(data){
    return (
        <div className={`carDetailSection ${data.addClass||""}`}>
            {data.titleSubItem ? 
                <CarDetailSectionTitleArea>
                    {data.title ? <CarDetailSectionTitle addClass={data.titleAddClass||""} title={data.title}/> : ""}
                    {data.titleSubItem}
                </CarDetailSectionTitleArea>
            :
                <>
                    {data.title ?
                        data.setIsDuplicate ?
                            <div className={"reservationDriverArea"}>
                                <CarDetailSectionTitle addClass={data.titleAddClass || ""} title={data.title}/>
                                <button
                                    style={{width: "120px"}}
                                    type="button"
                                    className={`fixedBox_chkItem ${data.isDuplicate === 1 ? "active" : ""}`}
                                    onClick={() => {
                                        data.setIsDuplicate(data.isDuplicate === 1 ? 0 : 1)

                                        if (data.isDuplicate === 0) {
                                            let newPaymentData = {...data.paymentData};
                                            newPaymentData.driver_name = data.paymentData.reservation_name
                                            newPaymentData.driver_phone = data.paymentData.reservation_phone
                                            newPaymentData.driver_birth = data.paymentData.birthday
                                            data.setPaymentData(newPaymentData);
                                        }
                                    }}
                                >
                                    <div className="fixedBox_chkItem_chk"/>
                                    <div className="fixedBox_chkItem_textBox">
                                        <h2 className="fixedBox_chkItem_name">
                                            운전자 정보 동일
                                        </h2>
                                    </div>
                                </button>
                            </div>
                            :
                            <CarDetailSectionTitle addClass={data.titleAddClass || ""} title={data.title}/>
                        : ""
                    }
                </>
            }
            <CarDetailArea>
                {data.children}
            </CarDetailArea>
            {data.captions && data.captions?.length > 0 ?
                <CarDetailSectionCaptionBox>
                    {data.captions?.map((item, i) => (
                        <DotText key={i} text={item}/>
                    ))}
                </CarDetailSectionCaptionBox>
            :""}
        </div>
    );
}

function CarDetailArea(data){
    return (
        <div className="carDetailArea">
            {data.children}
        </div>
    );
}

function CarCouponSection(data){
    return (
        <button type="button" onClick={()=>{data.func()}} className={`carCouponSection ${data.addClass||""}`}>
            <div className="carCouponArea">
                <div className="carCouponImgBox">
                    <div className="carCouponImg" style={{backgroundImage:`url('${data.couponImg}')`}}/>
                </div>
                <p className="carCouponText" dangerouslySetInnerHTML={{__html:data.couponText}}/>
            </div>
            <div className="carCouponBtn">
                쿠폰팩 확인하기
                <img src="/assets/images/basic/move_ww.svg" alt=""/>
            </div>
        </button>
    );
}

function CarDetailOptionTypeBox(data){
    return (
        <div className="carDetailOptionTypeBox">
            {data.data && data.data?.map((item,i)=>(
                <div key={i} className={`carDetailOptionType_item ${item.addClass||""}`}>
                    {item.icon ? <img src={`/assets/images/icon/${item.icon}.svg`} alt=""/> : ""}
                    <div className="carDetailOptionType_item_textBox">
                        <p className="carDetailOptionType_item_name" dangerouslySetInnerHTML={{__html:item.name}}/>
                        <p className={`carDetailOptionType_item_text ${item.color||""}`} dangerouslySetInnerHTML={{__html:item.text}}/>
                    </div>
                </div>
            ))}
        </div>
    );
}

function CarDetailTextArea(data){
    return (
        <div className={`carDetailTextArea ${data.addClass||""}`}>
            {data.title ? <CarDetailTextAreaTitle title={data.title}/> : ""}
            <div className="carDetailTextAreaItems">
                {data.children}
            </div>
        </div>
    );
}

function CarDetailTextAreaTitle(data){
    return (
        <h1 className="carDetailTextArea_title" dangerouslySetInnerHTML={{__html:data.title}}/>
    );
}

function CarDetailTextBox(data){
    return (
        <div className={`carDetailTextBox ${data.addClass||""}`}>
            <p className="carDetailText_name" dangerouslySetInnerHTML={{__html:data.name}}/>
            <p className="carDetailText_text" dangerouslySetInnerHTML={{__html:data.text}}/>
        </div>
    );
}

function CarDetailControllBasicText(data){
    return (
        <p className={`carDetailControll_basicText ${data.addClass||""}`} dangerouslySetInnerHTML={{__html:data.text}}/>
    );
}

function CarDetailControllBoxTitleBox(data){
    return (
        <div className="carDetailControllBox_titleBox">
            {data.title ? <h2 className="carDetailControllBox_title" dangerouslySetInnerHTML={{__html:data.title}}/> : ""}
            {data.subTitle ? <h2 className="carDetailControllBox_subTitle wbTextColor" dangerouslySetInnerHTML={{__html:data.subTitle}}/> : ""}
        </div>
    );
}

function CarDetailControllBox(data){
    return (
        <div className={`carDetailControllBox ${data.addClass||""}`}>
            {data.title || data.subTitle ? 
                <CarDetailControllBoxTitleBox
                    title={data.title}
                    subTitle={data.subTitle}
                />
             : ""}
            <div className="carDetailControllBox_contents">
                {data.children}
            </div>
        </div>
    );
}

function CarDetailOptionBox(data){
    return (
        <div className="carDetailOptionBox">
            {data.children}
        </div>
    );
}

function CarDetailOptionItem(data){

    return (
        <div className={`carDetailOptionItem ${data.active ? "active" : ""}`}>
            {data.text}
        </div>
    );
};

function SubAccordionBox(data){
    return (
        <div className="subAccordionBox">
            {data.children}
        </div>
    );
}

function SubAccordionItem(data){
    const slideItem = useRef(null);
    const [openChk,setOpenChk] = useState(false);

    const [slideChk,setSlideChk] = useState(true);

    useEffect(()=>{
        
    },[])

    return (
        <div className={`subAccordionItem ${openChk ? "active" : ""} ${data.addClass||""}`}>
            <button type="button" onClick={(e)=>{
                if(slideChk){
                    setSlideChk(false);
                    setTimeout(function(){
                        slideToggle(slideItem.current,"flex")
                        setOpenChk(!openChk)
                    },0);
                    setTimeout(() => {
                        setSlideChk(true);
                    }, 300);
                }
            }} className="subAccordionTitleBox">
                <div className="subAccordionTextBox">
                    <h1 className="subAccordionTitle" dangerouslySetInnerHTML={{__html:data.title}}/>
                </div>
                <img src="/assets/images/basic/sel.svg" alt=""/>
            </button>
            <div className="subAccordionAnswerBox" ref={slideItem}>
                {data.children}
            </div>
        </div>
    );
}

function CarDetailAnnouncementTextBox(data){
    return (
        <div className={`carDetailAnnouncementTextBox ${data.addClass||""}`}>
            <p className="carDetailAnnouncementText_name" dangerouslySetInnerHTML={{__html:data.name}}/>
            <p className="carDetailAnnouncementText_text" dangerouslySetInnerHTML={{__html:data.text}}/>
        </div>
    );
}

function CarDetailAnnouncementBox(data){
    return (
        <>
            {data.boxTitle ? <h2 className="carDetailAnnouncementBox_title" dangerouslySetInnerHTML={{__html:data.boxTitle}}/> : ""}
            <div className={`carDetailAnnouncementBox ${data.addClass||""}`}>
                {data.title || data.subTitle ? 
                    <div className="carDetailAnnouncement_titleBox">
                        <h2 className="carDetailAnnouncement_title" dangerouslySetInnerHTML={{__html:data.title}}/>
                        {data.subTitle ? <h2 className="carDetailAnnouncement_subTitle" dangerouslySetInnerHTML={{__html:data.subTitle}}/> : ""}
                    </div>
                : ""}
                <div className="carDetailAnnouncement_contents">
                    {data.children}
                </div>
            </div>
        </>
    );
}

function ReviewStarSelBtn(data){
    return (
        <button type="button" className="reviewStarSelBtn" onClick={()=>{data.func(data.itemVal)}}>
            <img src={`/assets/images/icon/${data.val >= data.itemVal ? "star_on" : "star_off"}.svg`} alt={`평점 ${data.val}점 (5점 만점)`}/>
        </button>
    );
}

function ReviewStarSelBox(data){
    return (
        <div className="reviewStarSelBox">
            <ReviewStarSelBtn
                val={data.val}
                itemVal={1}
                func={(val)=>{data.func(val)}}
            />
            <ReviewStarSelBtn
                val={data.val}
                itemVal={2}
                func={(val)=>{data.func(val)}}
            />
            <ReviewStarSelBtn
                val={data.val}
                itemVal={3}
                func={(val)=>{data.func(val)}}
            />
            <ReviewStarSelBtn
                val={data.val}
                itemVal={4}
                func={(val)=>{data.func(val)}}
            />
            <ReviewStarSelBtn
                val={data.val}
                itemVal={5}
                func={(val)=>{data.func(val)}}
            />
        </div>
    );
}

function AnnouncementPopupDotBox(data){
    return (
        <div className={`announcementPopupDotBox ${data.addClass||""}`}>
            {data.children}
        </div>
    );
}

function AnnouncementPopupTextArea(data){
    return (
        <div className="announcementPopupTextArea">
            {data.title ? 
                <h2 className="announcementPopupTextArea_title" dangerouslySetInnerHTML={{__html:data.title}}/>
            : ""}
            <div className="announcementPopupTextArea_contents">
                {data.children}
            </div>
        </div>
    );
}

function AnnouncementPopupTextBox(data){
    return (
        <div className={`announcementPopupTextBox ${data.addClass||""}`}>
            <p className="announcementPopupTextBox_name" dangerouslySetInnerHTML={{__html:data.name}}/>
            <p className="announcementPopupTextBox_text" dangerouslySetInnerHTML={{__html:data.text}}/>
        </div>
    );
}

function AnnouncementPopupSection(data){
    return (
        <>
            <AnnouncementPopupTextArea
                title="환불 수수료 안내"
            >
                <AnnouncementPopupTextBox 
                    name={"예약(결제) 시점 1시간 이내"}
                    text={data?.data?.one_hour_before ? `${data?.data?.one_hour_before}%` : "수수료 없음"}
                />
                <AnnouncementPopupTextBox 
                    name={"대여 시간 72시간 이전"}
                    text={data?.data?.three_day_before ? `${data?.data?.three_day_before}%` : "수수료 없음"}
                />
                <AnnouncementPopupTextBox 
                    name={"대여 시간 72시간 이내"}
                    text={data?.data?.three_day ? `${data?.data?.three_day}%` : "수수료 없음"}
                />
                <AnnouncementPopupTextBox 
                    name={"대여 시간 48시간 이내"}
                    text={data?.data?.two_day ? `${data?.data?.two_day}%` : "수수료 없음"}
                />
                <AnnouncementPopupTextBox 
                    name={"대여 시간 24시간 이내"}
                    text={data?.data?.one_day ? `${data?.data?.one_day}%` : "수수료 없음"}
                />
                <AnnouncementPopupTextBox 
                    name={"당일 대여 예약 취소"}
                    text={data?.data?.day_cancel ? `${data?.data?.day_cancel}%` : "수수료 없음"}
                />
                <AnnouncementPopupTextBox 
                    name={"대여 조건 미충족 시"}
                    text={data?.data?.condition_cancel ? `${data?.data?.condition_cancel}%` : "수수료 없음"}
                />
                <AnnouncementPopupTextBox 
                    name={"노쇼(NO SHOW) 발생 시"}
                    text={data?.data?.no_show_cancel ? `${data?.data?.no_show_cancel}%` : "수수료 없음"}
                />
            </AnnouncementPopupTextArea>
            {data?.data?.etc ? 
                <AnnouncementPopupDotBox>
                    <PreText text={data?.data?.etc}/>
                </AnnouncementPopupDotBox>
            :""}
        </>
    );
}

function AddProductItemInfoPriceDetailItem(data){
    return (
        <div className={`addProductItemInfo_priceDetailItem ${data.addClass||""}`}>
            <p className="addProductItemInfo_priceDetailItem_name" dangerouslySetInnerHTML={{__html:data.name}}/>
            <p className="addProductItemInfo_priceDetailItem_text" dangerouslySetInnerHTML={{__html:data.text}}/>
        </div>
    );
}

function AddProductItem(data){
    const slideItem = useRef(null);
    const [openChk,setOpenChk] = useState(false);

    const [slideChk,setSlideChk] = useState(true);
    
    return (
        <div className={`addProductItem ${data.addClass||""}`}>
            <div className="addProductItem_img backgroundImg" aria-label={data?.imgAlt ?? ("부가서비스-" + data.id)} style={{backgroundImage:`url('${data.img}')`}}/>
            <div className="addProductItemInfo">
                <p className="addProductItemInfo_category" dangerouslySetInnerHTML={{__html:data.category}}/>
                <h1 className="addProductItemInfo_name" dangerouslySetInnerHTML={{__html:data.name}}/>
                <div className={`addProductItemInfo_priceBox ${openChk ? "active" : ""}`}>
                    <button type="button" onClick={(e)=>{
                        if(slideChk){
                            setSlideChk(false);
                            setTimeout(function(){
                                slideToggle(slideItem.current,"block")
                                setOpenChk(!openChk)
                            },0);
                            setTimeout(() => {
                                setSlideChk(true);
                            }, 300);
                        }
                    }} className="addProductItemInfo_price_totalBox">
                        <h2 className="addProductItemInfo_price_totalItemName">총 결제 금액</h2>
                        <div className="addProductItemInfo_price_totalItem">
                            <p className="addProductItemInfo_price_total wbTextColor">{`${comFormat(data.totalPrice||"0")} 원`}</p>
                            <img src="/assets/images/basic/sel_bl.svg" alt=""/>
                        </div>
                    </button>
                    <div className="addProductItemInfo_priceDetailBox" ref={slideItem}>
                        <AddProductItemInfoPriceDetailItem
                            name="대여 수량"
                            text={`${comFormat(data.amount||"0")} 개`}
                        />
                        <AddProductItemInfoPriceDetailItem
                            name="총 대여일 수"
                            text={`${comFormat(data.day||"0")} 일`}
                        />
                        <AddProductItemInfoPriceDetailItem
                            name="대여 금액"
                            text={`일 ${comFormat(data.price||"0")} 원`}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

function CarSetInfoSection(data){
    return (
        <div className={`carSetInfoSection ${data.addClass||""}`}>
            {data.children}
        </div>
    );
}

function CarSetInfoItem(data){
    return (
        <>
        {data.type === "slideItem" ? 
            <button type="button" onClick={(e)=>{
                data.func()
            }} className={`carSetInfoItem ${data.addClass||""}`}>
                <p className="carSetInfoItem_name" dangerouslySetInnerHTML={{__html:data.name}}/>
                <div className="carSetInfoItem_textBox">
                    {data.text ? <p className="carSetInfoItem_text" dangerouslySetInnerHTML={{__html:data.text}}/> : ""}
                    <img src="/assets/images/basic/sel_w.svg"/>
                </div>
            </button>
        :
            <div className={`carSetInfoItem ${data.addClass||""}`}>
                <p className="carSetInfoItem_name" dangerouslySetInnerHTML={{__html:data.name}}/>
                {data.text ? <p className="carSetInfoItem_text" dangerouslySetInnerHTML={{__html:data.text}}/> : ""}
            </div>
        }
        </>
    );
}

function CarSetTermsItem(data){
    return (
        <div className={`carSetTermsItem ${data.addClass||""}`}>
            <p className="carSetTermsItem_name" dangerouslySetInnerHTML={{__html:data.name}}/>
            {data.btnFunc ? <button type="button" onClick={(e)=>{data.btnFunc()}} className={`carSetTermsItem_btn`}>보기</button> : ""}
        </div>
    );
}

function CarSetInfoCaption(data){
    return (
        <div className={`carSetInfoCaptionBox ${data.addClass||""}`}>
            {data.captions && data.captions?.map((item,i)=>(
                <p className="carSetInfoCaption" key={i} dangerouslySetInnerHTML={{__html:item}}/>
            ))}
            {data.btn ? <button type="button" onClick={()=>{data.func()}} className="carSetInfoCaption_btn">{data.btn}</button> : ""}
        </div>
    );
}

function CarSetCaptionList(data){
    return (
        <div className={`carSetCaptionList ${data.addClass||""}`}>
            {data.captions && data.captions?.map((item,i)=>(
                <div className="carSetCaptionListItem" key={i}>
                    <p className="carSetCaptionListItem_type wbTextColor" dangerouslySetInnerHTML={{__html:item.type}}/>
                    <p className="carSetCaptionListItem_text" dangerouslySetInnerHTML={{__html:item.text}}/>
                </div>
            ))}
        </div>
    );
}

function CarRentDetailOptionBox(data){
    return (
        <div className={`carRentDetailOptionBox ${data.addClass||""}`}>
            {data.children}
        </div>
    );
}

function CarReviewListStar(data){
    return (
        <div className="carReviewListStarBox">
            <img src={`/assets/images/icon/${data.grade >= 1 ? "star_on" : "star_off"}.svg`} className="carReviewListStarItem" alt={`평점 ${data.grade}점 (5점 만점)`}/>
            <img src={`/assets/images/icon/${data.grade >= 2 ? "star_on" : "star_off"}.svg`} className="carReviewListStarItem" alt={`평점 ${data.grade}점 (5점 만점)`}/>
            <img src={`/assets/images/icon/${data.grade >= 3 ? "star_on" : "star_off"}.svg`} className="carReviewListStarItem" alt={`평점 ${data.grade}점 (5점 만점)`}/>
            <img src={`/assets/images/icon/${data.grade >= 4 ? "star_on" : "star_off"}.svg`} className="carReviewListStarItem" alt={`평점 ${data.grade}점 (5점 만점)`}/>
            <img src={`/assets/images/icon/${data.grade >= 5 ? "star_on" : "star_off"}.svg`} className="carReviewListStarItem" alt={`평점 ${data.grade}점 (5점 만점)`}/>
        </div>
    );
}

function CarReviewList(data){
    return (
        <div className={`carReviewList ${data.addClass||""}`}>
            <div className="carReviewList_gradeBox">
                <CarReviewListStar grade={data.grade||0}/>
                {data.reportFunc ? <button type="button" onClick={()=>{data.reportFunc(data)}} className="btn_reviewListReport">신고</button> : ""} 
            </div>
            <div className="carReviewList_infoBox">
                <p className="carReviewList_name" dangerouslySetInnerHTML={{__html:data.name||"-"}}/>
                {data.created_at ? <p className="carReviewList_date" dangerouslySetInnerHTML={{__html: setDateTime(data.created_at,"yymmdd","hymd")}}/> : ""}
            </div>
            <p className="carReviewList_text" dangerouslySetInnerHTML={{__html:data.contents||"-"}}/>
        </div>
    );
}

function CaptionBox(data){
    return (
        <div className={`captionBox ${data.addClass||""}`}>
            {data.children}
        </div>
    );
}

function CarRentInsuranceTextItem(data){
    return (
        <div className={`carRentInsuranceTextItem ${data.addClass||""}`}>
            {data.name ? <p className={`carRentInsuranceTextItem_name ${data.nameAddClass||""}`} dangerouslySetInnerHTML={{__html:data.name}}/> : ""}
            {data.text ? <p className={`carRentInsuranceTextItem_text ${data.textAddClass||""}`} dangerouslySetInnerHTML={{__html:data.text}}/> : ""}
        </div>
    );
}

function CarRentInsuranceItem(data){
    return (
        <button type="button" className={`carRentInsuranceItem ${data.value === data.id ? "active" : ""}`} onClick={()=>{data.func(data.id)}}>
            <div className="carRentInsuranceItem_chk"/>
            <div className="carRentInsuranceItem_textBox">
                <CarRentInsuranceTextItem
                    addClass="carRentInsurance_titleItem"
                    textAddClass="pcItemT"
                    name={`${data.name}<span>l</span>만 ${data.driving_age||"00"}세 이상 / 운전경력 ${data.driving_experience||"00"}년 이상`}
                    text={data.type === "edit" ? null : `+ ${comFormat(data.price||0)} 원`}
                />
                <CarRentInsuranceTextItem
                    addClass=""
                    name={"보상한도"}
                    text={`${data.limit_compensation||""} (${data.limit_compensation ? "제한" : "무제한"})`}
                />
                <CarRentInsuranceTextItem
                    addClass=""
                    name={"면책금"}
                    text={`${data.indemnity||""} (${data.indemnity ? "발생" : "면제"})`}
                />
                <CarRentInsuranceTextItem
                    addClass=""
                    name={"휴차보상료"}
                    text={data.furlough_compensation_fee||"-"}
                />
                <CarRentInsuranceTextItem
                    addClass=""
                    name={"단독사고 보장"}
                    text={data.single_accident||"-"}
                />
                <CarRentInsuranceTextItem
                    addClass=""
                    name={"휠/타이어 파손 보장"}
                    text={data.tire_damage_guarantees||"-"}
                />
                <CarRentInsuranceTextItem
                    addClass={`carRentInsurance_titleItem ${data.type === "edit" ? "" : "mItemT"}`}
                    textAddClass={data.type === "edit" ? "wbTextColor" : ""}
                    name={null}
                    text={`+ ${comFormat(data.price||0)} 원`}
                />
            </div>
        </button>
    );
}

function PopupCaptionTextItem(data){
    return (
        <div className={`popupCaptionTextItem ${data.addClass||""}`}>
            {data.name ? <p className={`popupCaptionTextItem_name ${data.nameAddClass||""}`} dangerouslySetInnerHTML={{__html:data.name}}/> : ""}
            {data.text ? <p className={`popupCaptionTextItem_text ${data.textAddClass||""}`} dangerouslySetInnerHTML={{__html:data.text}}/> : ""}
        </div>
    );
}

function PopupCaptionTextBox(data){
    return (
        <div className={`popupCaptionTextBox ${data.addClass||""}`}>
            {data.children}
        </div>
    );
}

function AddProductListBox(data){
    return (
        <div className={`addProductListBox ${data.addClass||""}`}>
            {data.children}
        </div>
    );
}

function AddProductListItem(data){
    return (
        <div className={`addProductListItem ${data.addClass||""}`}>
            <div className={`addProductListItemImg backgroundImg ${data.addClass||""}`} aria-label={data?.imgAlt ?? ("부가서비스-" + data?.id)} style={{backgroundImage:`url('${data.img}')`}}/>
            <p className="addProductListItem_cate" dangerouslySetInnerHTML={{__html:data.category}}/>
            <h2 className="addProductListItem_name" dangerouslySetInnerHTML={{__html:data.name}}/>
            <p className="addProductListItem_price wbTextColor" dangerouslySetInnerHTML={{__html:`${comFormat(data.price||"0")} 원/일`}}/>
            <CountInput
                val={data.qty}
                qty={null}
                optionQty={null}
                maxQty={data.amount}
                func={data.countFunc}
                excessFunc={()=>{}}
            />
        </div>
    );
}

function CarSetInfoSlideSection(data){
    const slideItem = useRef(null);
    const [openChk,setOpenChk] = useState(data.openType ? true : false);

    const [slideChk,setSlideChk] = useState(true);

    useEffect(()=>{
        if((data.openType || data.notSlideType) && slideItem.current){
            slideItem.current.style.display = "block";
        }
    },[]);

    if(data.notSlideType){
        return (
            <CarSetInfoSection addClass={`carSetInfoSlideSection notSlideType active`}>
                <CarSetInfoItem
                    addClass={data.titleAddClass||"mSize"}
                    name={data.titleName}
                    text={data.titleText}
                />
                <div className="carSetInfoSlideBox" ref={slideItem}>
                    {data.children}
                </div>
            </CarSetInfoSection>
        );
    }
    
    return (
        <CarSetInfoSection addClass={`carSetInfoSlideSection ${openChk ? "active" : ""}`}>
            <CarSetInfoItem
                addClass={data.titleAddClass||"mSize"}
                name={data.titleName}
                text={data.titleText}
                type="slideItem"
                func={()=>{
                    if(slideChk){
                        setSlideChk(false);
                        setTimeout(function(){
                            slideToggle(slideItem.current,"block")
                            setOpenChk(!openChk)
                        },0);
                        setTimeout(() => {
                            setSlideChk(true);
                        }, 300);
                    }
                }}
            />
            <div className="carSetInfoSlideBox" ref={slideItem}>
                {data.children}
            </div>
        </CarSetInfoSection>
    );
}

function PaymentTypeBtnBox(data){
    return (
        <div className={`paymentTypeBtnBox ${data.addClass||""}`}>
            {data.children}
        </div>
    );
}

function PaymentTypeBtn(data){
    return (
        <button type="button" onClick={()=>{data.func(data.id)}} className={`paymentTypeBtn ${data.addClass||""} ${data.value === data.id ? "active" : ""}`} dangerouslySetInnerHTML={{__html:data.name}}></button>
    );
}

function PaymentCardBtnBox(data){
    return (
        <div className={`paymentCardBtnBox paymentTypeBtn ${data.addClass||""} ${data.value === data.id ? "active" : ""}`}>
            <p className="paymentCardBtn_text" onClick={()=>{data.func(data.id)}} dangerouslySetInnerHTML={{__html:data.name}}/>
            <div className="paymentCardBtn_slideBox">
                {data.children}
            </div>
        </div>
    );
}

function PaymentSuccessTextBox(data){

    return (
        <div className="paymentSuccessTextBox">
            <img src="/assets/images/icon/congrats.svg"/>
            <h1 className="paymentSuccessText_title" dangerouslySetInnerHTML={{__html:data.title}}/>
            <p className="paymentSuccessText_text" dangerouslySetInnerHTML={{__html:data.text}}/>
        </div>
    );
}

function CouponPackItemBox(data){
    return (
        <div className={`couponPackItemBox ${data.addClass||""}`}>
            {data.children}
        </div>
    );
}

function CouponPackItemTextBox(data){
    return (
        <div className={`couponPackItemTextBox ${data.addClass||""}`}>
            {data.name ? <p className={`couponPackItemTextBox_name ${data.nameAddClass||""}`} dangerouslySetInnerHTML={{__html:data.name}}/> : ""}
            {data.text ? <p className={`couponPackItemTextBox_text ${data.textAddClass||""}`} dangerouslySetInnerHTML={{__html:data.text}}/> : ""}
        </div>
    );
}

function CouponPackItem(data){
    return (
        <div className={`couponPackItem ${data.addClass||""}`}>
            <div className="couponPackItem_imgBox">
                {data.couponImg ? <div className="couponPackItem_img backgroundImg" style={{backgroundImage:`url('${data.couponImg}')`}}/> : ""}
                {data.barcode_image ? <img src={data.barcode_image}/> : ""}
            </div>
            <h1 className="couponPackItem_name wbTextColor" dangerouslySetInnerHTML={{__html:data.name}}/>
        </div>
    );
}

function PopupCaptionDotTextBox(data){
    return (
        <div className={`popupCaptionDotTextBox ${data.addClass||""}`}>
            {data.children}
        </div>
    );
}

function BaiscPopupTextBox(data){
    return (
        <div className={`baiscPopupTextBox ${data.addClass||""}`}>
            {data.title ? <h2 className="baiscPopupTextBox_title" dangerouslySetInnerHTML={{__html:data.title}}/> : ""}
            {data.text ? <p className="baiscPopupTextBox_text" dangerouslySetInnerHTML={{__html:data.text}}/> : ""}
        </div>
    );
}

function ReservationEditSetSection(data){
    return (
        <div className={`reservationEditSetSection ${data.addClass||""}`}>
            {data.children}
        </div>
    );
}

function ReservationEditSetArea(data){
    return (
        <div className={`reservationEditSetArea ${data.addClass||""}`}>
            {data.title ? <h2 className={`reservationEditSetArea_title ${data.titleAddClass}`} dangerouslySetInnerHTML={{__html:data.title}}/> : ""}
            <div className="reservationEditSetBox">
                {data.children}
            </div>
        </div>
    );
}

function ResetBtn(data){
    return (
        <button type="button" className="resetBtn" onClick={()=>{data.func()}}>
            <img src={`/assets/images/basic/reset.svg`}/>
            초기화
        </button>
    );
}

function PopupNameTextComBox(data){
    return (
        <div className={`popupNameTextComBox ${data.addClass||""}`}>
            <p className="popupNameTextComBox_name" dangerouslySetInnerHTML={{__html:data.name}}/>
            <p className="popupNameTextComBox_text" dangerouslySetInnerHTML={{__html:data.text}}/>
        </div>
    );
}

function PopupBottomCaption(data){
    return (
        <p className="popupBottomCaption" dangerouslySetInnerHTML={{__html:data.text}}/>
    );
}

export {FixedContents,CarDetailSection,CarReviewListStar,CarDetailSectionCaptionBox,CarDetailSectionTitleArea,CarDetailSectionSubTitle,CarDetailArea,CarDetailSectionTitle,CarCouponSection,CarDetailOptionTypeBox,CarDetailTextBox,CarDetailTextArea,CarDetailTextAreaTitle,CarDetailControllBox,CarDetailControllBoxTitleBox,CarDetailControllBasicText,SubAccordionBox,SubAccordionItem,CarDetailOptionBox,CarDetailOptionItem,CarDetailAnnouncementTextBox,CarDetailAnnouncementBox,ReviewStarSelBox,AnnouncementPopupDotBox,AnnouncementPopupTextArea,AnnouncementPopupTextBox,AnnouncementPopupSection,AddProductItem,CarSetInfoSection,CarSetInfoItem,CarSetTermsItem,CarSetInfoCaption,CarSetCaptionList,CarReviewList,CarRentDetailOptionBox,CaptionBox,CarRentInsuranceItem,PopupCaptionTextBox,PopupCaptionTextItem,AddProductListBox,AddProductListItem,CarSetInfoSlideSection,PaymentTypeBtnBox,PaymentTypeBtn,PaymentCardBtnBox,PaymentSuccessTextBox,CouponPackItem,CouponPackItemBox,PopupCaptionDotTextBox,BaiscPopupTextBox,ReservationEditSetSection,ReservationEditSetArea,ResetBtn,PopupNameTextComBox, PopupBottomCaption};

